import React, { useContext, useMemo } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import DirectAdmissionFlow from './DirectAdmissionFlow';
import CeeFlow from './CeeFlow';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
const Cee = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const {
    selectedCourseData
  } = useContext(CourseContext);
  const isSohCourse = useMemo(() => {
    return selectedCourseData?.crmProductName?.includes('BVoc');
  }, [selectedCourseData]);
  return <section data-sentry-component="Cee" data-sentry-source-file="index.tsx">
      {registrationDetails?.isEligibleForDirectAdmission || isSohCourse ? <DirectAdmissionFlow /> : <CeeFlow />}
    </section>;
};
export default Cee;